/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A kilobyte (KB) is 1000 bytes; a kibibyte (KiB) is 1024 bytes. Storage is usually sold in decimal (KB/MB/GB) while operating systems often report binary (KiB/MiB/GiB), which is why a '1 TB' drive shows as about 931 GiB.`)
};

const es_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un kilobyte (KB) son 1000 bytes; un kibibyte (KiB) son 1024 bytes. El almacenamiento generalmente se vende en decimal (KB/MB/GB) mientras que los sistemas operativos a menudo informan binario (KiB/MiB/GiB), por eso una unidad de 1 TB aparece como aproximadamente 931 GiB.`)
};

const de_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Kilobyte (KB) entspricht 1000 Byte; ein Kibibyte (KiB) entspricht 1024 Byte. Speicherplatz wird meist dezimal (KB/MB/GB) verkauft, während Betriebssysteme oft binär (KiB/MiB/GiB) angeben, weshalb ein „1-TB”-Laufwerk mit etwa 931 GiB angezeigt wird.`)
};

const nl_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een kilobyte (KB) is 1000 bytes; een kibibyte (KiB) is 1024 bytes. Opslag wordt meestal in decimaal (KB/MB/GB) verkocht terwijl besturingssystemen vaak binair (KiB/MiB/GiB) rapporteren, daarom toont een schijf van 1 TB ongeveer 931 GiB.`)
};

const fr_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un kilooctet (KB) représente 1000 octets; un kibioctet (KiB) représente 1024 octets. Le stockage est généralement vendu en décimal (KB/MB/GB) tandis que les systèmes d'exploitation rapportent souvent en binaire (KiB/MiB/GiB), ce qui explique pourquoi un lecteur « 1 TB » s'affiche environ 931 GiB.`)
};

const it_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un kilobyte (KB) è 1000 B; un kibibyte (KiB) è 1024 B. L'archiviazione è solitamente venduta in decimale (KB/MB/GB) mentre i sistemi operativi spesso riportano binaria (KiB/MiB/GiB), motivo per cui un'unità di archiviazione '1 TB' appare come circa 931 GiB.`)
};

const pt_br2_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um kilobyte (KB) é 1000 bytes; um kibibyte (KiB) é 1024 bytes. O armazenamento é geralmente vendido em decimal (KB/MB/GB) enquanto os sistemas operacionais frequentemente relatam binário (KiB/MiB/GiB), razão pela qual um drive de '1 TB' mostra aproximadamente 931 GiB.`)
};

const pt_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um quilobyte (KB) são 1000 bytes; um quibibyte (KiB) são 1024 bytes. O armazenamento é normalmente vendido em decimal (KB/MB/GB) enquanto os sistemas operativos frequentemente apresentam binário (KiB/MiB/GiB), é por isso que uma unidade de 1 TB aparece como aproximadamente 931 GiB.`)
};

const ja_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キロバイト(KB)は1000バイト、キビバイト(KiB)は1024バイトです。ストレージは通常10進数(KB/MB/GB)で販売されていますが、オペレーティングシステムはしばしばバイナリ(KiB/MiB/GiB)で報告しています。これが「1 TB」ドライブが約931 GiBと表示される理由です。`)
};

const zh_ds_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`千字节(KB)等于 1000 字节;KiB 等于 1024 字节。存储设备通常以十进制单位(KB/MB/GB)标称容量,而操作系统往往以二进制单位(KiB/MiB/GiB)显示容量,这就是为什么一块标称为“1 TB”的硬盘会显示为约 931 GiB。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_faq1_a", locale)
	if (locale === "en") return en_ds_faq1_a(inputs)
	if (locale === "es") return es_ds_faq1_a(inputs)
	if (locale === "de") return de_ds_faq1_a(inputs)
	if (locale === "nl") return nl_ds_faq1_a(inputs)
	if (locale === "fr") return fr_ds_faq1_a(inputs)
	if (locale === "it") return it_ds_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_ds_faq1_a(inputs)
	if (locale === "pt") return pt_ds_faq1_a(inputs)
	if (locale === "ja") return ja_ds_faq1_a(inputs)
	return zh_ds_faq1_a(inputs)
};